import { createElementBlock as c, openBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60"
};
function n(r, e) {
  return l(), c("svg", t, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M36.91 19.815q0-.176.078-.335a12.5 12.5 0 0 0 1.25-5.458c0-7.024-5.8-12.718-12.955-12.718-7.154 0-12.954 5.694-12.954 12.718 0 5.133 3.097 9.555 7.558 11.565a.69.69 0 0 1 .414.621.643.643 0 0 1-.903.594C14.445 24.6 11 19.706 11 14.022 11 6.278 17.395 0 25.283 0c7.889 0 14.284 6.278 14.284 14.022 0 2.196-.515 4.275-1.432 6.126-.328.66-1.226.401-1.226-.334M21.761 13.37c0-1.981 1.636-3.587 3.654-3.587s3.654 1.606 3.654 3.587V30c0 .18.149.326.332.326a.33.33 0 0 0 .332-.326v-9.911a4 4 0 0 1 1.993-.524c1.96 0 3.588 1.388 3.923 3.216l-.003.045v9.783c0 .18.149.326.332.326a.33.33 0 0 0 .332-.326v-7.917a4 4 0 0 1 2.06-.562c1.847 0 3.401 1.235 3.853 2.91v7.525c0 .18.149.326.332.326a.33.33 0 0 0 .332-.326v-6.571a4 4 0 0 1 2.126-.603c2.201 0 3.986 1.752 3.986 3.913v11.087q0 .103-.005.204.02.99-.035 2.079C48.96 53.138 41.979 60 33.368 60c-6.708 0-12.426-4.163-14.627-10.005l-5.954-12.78c-1.159-2.487-.044-5.426 2.49-6.564 2.398-1.077 5.208-.154 6.485 2.057zm10.419 3.881c-.217.446.09 1.01.595 1.01.228 0 .44-.121.541-.322.599-1.18.935-2.51.935-3.917 0-4.863-4.016-8.805-8.969-8.805s-8.968 3.942-8.968 8.805c0 2.58 1.13 4.902 2.933 6.512.422.378 1.053.056 1.053-.505a.73.73 0 0 0-.244-.537 7.42 7.42 0 0 1-2.414-5.47c0-4.142 3.42-7.5 7.64-7.5s7.64 3.358 7.64 7.5a7.36 7.36 0 0 1-.742 3.229",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const v = { render: n };
export {
  v as default,
  n as render
};
